import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import { EXPERIENCE_TRACKER_LOCATION_BOARD } from '../../../model/constants';

export const getUpdateFieldExperience = () =>
	new UFOExperience(`${EXPERIENCE_TRACKER_LOCATION_BOARD}.field.update`, {
		performanceType: ExperiencePerformanceTypes.InlineResult,
		type: ExperienceTypes.Experience,
	});
